import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-slate-200 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div>
            <img
              src="/uploads/media/enneagram-free-logo.svg"
              alt="Enneagram Free"
              className="h-9 mb-4"
            />
            <p className="text-sm text-slate-500 leading-relaxed max-w-xs">
              Helping you discover your true potential through Enneagram insights and personalized coaching.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-slate-900 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-slate-500 hover:text-indigo-600 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/experts" className="text-sm text-slate-500 hover:text-indigo-600 transition-colors">
                  Find an Expert
                </Link>
              </li>
              <li>
                <Link to="/learning" className="text-sm text-slate-500 hover:text-indigo-600 transition-colors">
                  Learning Modules
                </Link>
              </li>
              <li>
                <Link to="/for-contributors" className="text-sm text-slate-500 hover:text-indigo-600 transition-colors">
                  Become a Contributor
                </Link>
              </li>
            </ul>
          </div>

          {/* Enneagram Types */}
          <div>
            <h4 className="text-sm font-semibold text-slate-900 mb-4">Enneagram Types</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/enneagram" className="text-sm text-slate-500 hover:text-indigo-600 transition-colors font-medium">
                  All Nine Types →
                </Link>
              </li>
              {[
                [1, 'The Reformer'],
                [2, 'The Helper'],
                [3, 'The Achiever'],
                [4, 'The Individualist'],
                [5, 'The Investigator'],
                [6, 'The Loyalist'],
                [7, 'The Enthusiast'],
                [8, 'The Challenger'],
                [9, 'The Peacemaker'],
              ].map(([num, name]) => (
                <li key={num}>
                  <Link
                    to={`/enneagram/type/${num}`}
                    className="text-sm text-slate-500 hover:text-indigo-600 transition-colors"
                  >
                    Type {num} — {name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-slate-900 mb-4">Contact Us</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/contact" className="text-sm text-slate-500 hover:text-indigo-600 transition-colors">
                  Support Center
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-slate-500 hover:text-indigo-600 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-slate-500 hover:text-indigo-600 transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
            <Link
              to="/experts"
              className="inline-flex items-center gap-2 mt-5 px-4 py-2.5 rounded-xl bg-indigo-600 text-white text-sm font-semibold hover:bg-indigo-700 transition-colors shadow-primary"
            >
              Find an Expert
            </Link>
          </div>
        </div>

        <div className="border-t border-slate-100 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <p className="text-xs text-slate-400">
              © {new Date().getFullYear()} Enneagram Free. All rights reserved.
            </p>
            <Link to="/privacy" className="text-xs text-slate-400 hover:text-indigo-600 transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-xs text-slate-400 hover:text-indigo-600 transition-colors">
              Terms of Service
            </Link>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-slate-400">
            Made with <Heart className="h-3.5 w-3.5 text-red-400" /> for spiritual growth
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
